import { Icon } from '@iconify/react'
import { FAQ } from '@pepper/ui'
import type { Faq } from '@pepper/utils/src/types/seo'

import LoadingBar from 'components/LoadingBar'

import s from './FAQs.module.css'

const FAQS_COUNT = 5

interface Props {
  faqs?: Faq[]
  alert?: 'success' | 'error'
  alertText?: string
  logoType?: 'img' | 'icon'
}

function FAQs({ faqs, alert, alertText, logoType }: Props) {
  const faqLoaders = new Array(FAQS_COUNT).fill(null)

  return (
    <section>
      {alert ? (
        <div className={s.alert}>
          {alert === 'error' ? (
            <Icon icon="lucide:x-circle" width={24} height={24} color="red" />
          ) : (
            <Icon
              icon="lucide:circle-check"
              width={24}
              height={24}
              color="var(--color-green-500)"
            />
          )}

          <p>{alertText}</p>
        </div>
      ) : null}

      {!faqs?.length && (
        <div className={s.loaderWrapper}>
          {faqLoaders.map((_, index) => (
            <div className={s.loader} key={index}>
              <LoadingBar height={30} width={30} borderRadius={8} />
              <LoadingBar borderRadius={4} width={500} />
            </div>
          ))}
        </div>
      )}

      {faqs?.map((question, index) => {
        return (
          <FAQ
            key={index}
            faq={{
              question: question.question,
              answer: question.snippet,
              link: question.link,
            }}
            logoType={logoType}
          />
        )
      })}
    </section>
  )
}

export default FAQs
